
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notificari",
      function () {
        return require("private-next-pages/notificari.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/notificari"])
      });
    }
  